import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* eventSagas() {
  yield mapSagasFromConfigurations('event')(configurations)
}

export default eventSagas;


// WEBPACK FOOTER //
// ./src/state/modules/event/sagas.js